var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.level===1?'width: 100%;height: 100%':'')},[_c('keep-alive',{attrs:{"exclude":_vm.exclude,"max":"4"}},[(_vm.$route.meta.keepAlive && _vm.$route.meta.level===_vm.level)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive || _vm.$route.meta.level!==_vm.level)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3d2e2a8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/keep-alive-router.vue
// module id = null
// module chunks = 